<template>
    <router-view />
    <Footer />
</template>
<script setup>
import Footer from "@/components/FooterCom.vue";
</script>
<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #FFFFFF;
    font-family: Inter, Inter;
}
</style>
